import { gridSize, borderRadius } from '@atlaskit/theme/constants';
var gs = function (times) { return gridSize() * times + "px"; };
var br = function (times) {
    if (times === void 0) { times = 1; }
    return borderRadius() * times + "px";
};
export { gs, br };
//# sourceMappingURL=index.js.map